import React, { useContext, useEffect } from "react";
import AHPSelect from "../../components/AHPSelect/AHPSelect";
import DateRangePicker from "../../components/Calendar/DateRangePicker";
import { FIELD_WIDTHS } from "../../config/layoutConfig";
import {
  adultSelectOptions,
  childrenSelectOptions,
  roomSelectOptions,
} from "./lodgeConstants";
import { useLocation } from "react-router";
import { AppContext } from "../../context";
import ImmediateConfirmation from "../../components/ImmediateConfirmation/ImmediateConfirmation";
import { searchLodges } from "./searchLodges";

function LodgeFilter({ setStores }) {
  let info = useContext(AppContext);

  useEffect(() => {
    (async () => {
      let lodges = await searchLodges(info);
      setStores(lodges);
    })();
  }, [info.villages, info.name, info.lodge, info.immediateConfirmation]);

  return (
    <div className="ahp-service-filter">
      <DateRangePicker />
      <div>
        <div style={{ display: "inline", marginTop: 6 }}>
          {info.t("adults")}:
        </div>
        <AHPSelect
          label={info.t("adults")}
          type="lodge"
          field="adults"
          options={adultSelectOptions}
          width={FIELD_WIDTHS.XS}
        />
      </div>
      <div>
        <div style={{ display: "inline", marginTop: 6 }}>
          {info.t("children")}:
        </div>
        <AHPSelect
          label={info.t("children")}
          width={FIELD_WIDTHS.XS}
          type="lodge"
          field="children"
          options={childrenSelectOptions}
        />
      </div>
      <div>
        <div style={{ display: "inline", marginTop: 6 }}>
          {info.t("rooms")}:
        </div>
        <AHPSelect
          label={info.t("rooms")}
          width={FIELD_WIDTHS.XS}
          type="lodge"
          field="rooms"
          options={roomSelectOptions}
        />
      </div>
      <ImmediateConfirmation />
    </div>
  );
}

export default LodgeFilter;
